import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import ThinkificConfigForm from './ThinkificConfigForm';
import { useThinkificConfig } from './useThinkificConfig';


export const ThinkificLmsConfiguration = () => {
  const currentUser = useSelector((state: RootState) => state.currentUser);
  const {
    config,
    isLoading,
    handleUpdateConfiguration,
    setConfig,
  } = useThinkificConfig(currentUser.organization_id);
  return (
    <div className="p-4 bg-white border rounded shadow-md">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold mb-4">Thinkific Configuration</h2>
      </div>
      {isLoading ? (
        <p>Loading...</p>

      ) : (
        <ThinkificConfigForm
          config={{
            lmsUrl: config.lmsUrl,
            proviewAdminUsername: config.proviewAdminUsername,
            proviewAdminPassword: config.proviewAdminPassword,
            proviewName:config.proviewName
          }}
          setConfig={setConfig}
          handleUpdateConfiguration={handleUpdateConfiguration}
        />
      )}
    </div>
  );
};
